/* eslint-disable */
import moment from "moment";
var pixelWidth = require('string-pixel-width');



export const maxColumnWidth = (columnName, array) => {
    var x = array.reduce((previousValue, currentValue) =>
        previousValue =
        previousValue.length > currentValue[columnName].length ? previousValue : currentValue[columnName], 0
    );

    const headerwidth = pixelWidth(columnName, { size: 16 }) + 45;

    const width = pixelWidth(x, { size: 15 }) + 35;
    let datatosend = headerwidth > width ? headerwidth : width

    return datatosend
}
export const formattedDate = (value, format) => {
    var newValue =  moment(value).format(format)

    return newValue
}


export const parseData = (responseData) => {

    return responseData.map((row, key) => {

        Object.keys(row).map(function (k) {
            //In the below we trim the string values. and if value is null then replace with string " "
            row[k] =
                row[k] !== null && (typeof row[k]  === "string")
                    ?
                    row[k].trim()
                    : row[k] === null ? "" : row[k];

            //if data does not contain field "id" it generate it.
            if (!Object.keys(row).includes("generated_id")) {
                row["generated_id"] = key
            }
            return row
        }
        )
        return row
    })

}
 export const addDayToCurrentDate = (days) => { 
    let currentDate = new Date()
    return new Date(currentDate.setDate(currentDate.getDate() + days))
  }
  export const subDayToCurrentDate = (days) => { 
    let currentDate = new Date()
    return new Date(currentDate.setDate(currentDate.getDate() - days))
  }

  export const  getUniqueList =(arr, key) =>{
    return [...new Map(arr.map(item => [item[key], item])).values()]
}

export default () => {
    return { parseData, maxColumnWidth ,addDayToCurrentDate ,subDayToCurrentDate,getUniqueList};
}